import cloudflareAssets from "@/assets/cloudflareAssets";
import type { CloudflareAsset } from "@/shared/common/enums";
import type { ISVGIconProps } from "@ab.uitools/ui-library/components/SVGIcons/types";
import classNames from "classnames";

interface Props extends ISVGIconProps {
  path: CloudflareAsset;
  width?: number;
  height?: number;
  alt?: string;
}

export const CloudFlareImage = ({
  className = "",
  size,
  onClick,
  id,
  dataId,
  path,
  width,
  height,
  alt = "",
  type,
}: Props) => {
  return (
    <img
      src={cloudflareAssets?.[path]}
      className={classNames("svg-icon", {
        [`svg-icon__size-${size}`]: size,
        [`svg-icon__type-${type}`]: type,
        [className]: className,
      })}
      onClick={onClick}
      id={id}
      data-id={dataId ? `${dataId}-svg-icon` : ""}
      alt={alt}
      {...(width && { width })}
      {...(height && { height })}
    />
  );
};
